export class StylingModule{
    id!: string

    idPlatform!: string;
    idUnit!: string;

    name!: string
    hideStyle!: boolean
    styleDefault!: string
  }
  